// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"c1ba12e0","450":"cec821dc"}[chunkId] + ".chunk.js";
};